<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>This book and all of its contents is the work of a very tired thirty-something-mommy. All the names, characters, places, events, incidents and locations are a product of the authors exaggerated imagination inspired by real life events. As such, they are intended to be used in a fictitious and light-hearted manner. It is a collection of personal experiences (enhanced, of course) and offers a culmination of scenarios that women go through in an attempt to survive day-to-day life.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?0fbf7c5d